// Subscription.jsx
import { useState } from 'react'
import { Search, Plus, Crown, Users, TrendingUp, DollarSign, Pencil, Trash2, Check, ChevronRight } from 'lucide-react'

const PLANS = [
  { id:'PLN-001', name:'Free',       price:'$0',   billing:'—',      users:120, limit:'5 items',   color:'#64748B', colorGlow:'rgba(100,116,139,0.15)', features:['Basic analytics','5 item limit','Email support'] },
  { id:'PLN-002', name:'Starter',    price:'$19',  billing:'/mo',    users:340, limit:'50 items',  color:'#10B981', colorGlow:'rgba(16,185,129,0.15)',  features:['Full analytics','50 items','Priority email','CSV export'] },
  { id:'PLN-003', name:'Pro',        price:'$79',  billing:'/mo',    users:580, limit:'Unlimited', color:'#4F46E5', colorGlow:'rgba(79,70,229,0.18)',   features:['Advanced analytics','Unlimited items','API access','24/7 support','Custom reports'], popular:true },
  { id:'PLN-004', name:'Enterprise', price:'$299', billing:'/mo',    users:210, limit:'Unlimited', color:'#F59E0B', colorGlow:'rgba(245,158,11,0.15)',  features:['Everything in Pro','Dedicated manager','SSO / SAML','SLA 99.9%','Custom integrations'] },
]

const SUBS = [
  { id:'SUB-001', user:'Sarah Mitchell', email:'sarah@acme.com',   plan:'Enterprise', amount:'$299', start:'Jan 12, 2025', renew:'Jun 12, 2025', status:'active' },
  { id:'SUB-002', user:'James Holloway', email:'james@corp.io',    plan:'Pro',        amount:'$79',  start:'Feb 4, 2025',  renew:'Jun 4, 2025',  status:'active' },
  { id:'SUB-003', user:'Priya Sharma',   email:'priya@start.co',   plan:'Starter',    amount:'$19',  start:'Mar 8, 2025',  renew:'Jun 8, 2025',  status:'active' },
  { id:'SUB-004', user:'Luca Martini',   email:'luca@design.eu',   plan:'Pro',        amount:'$79',  start:'Mar 15, 2025', renew:'Jun 15, 2025', status:'cancelled' },
  { id:'SUB-005', user:'Emily Chen',     email:'emily@techco.com', plan:'Enterprise', amount:'$299', start:'Apr 1, 2025',  renew:'Jul 1, 2025',  status:'active' },
  { id:'SUB-006', user:'Anika Patel',    email:'anika@health.in',  plan:'Starter',    amount:'$19',  start:'May 2, 2025',  renew:'Jun 2, 2025',  status:'trial' },
]

const STATUS = {
  active:    { cls:'badge-active',  l:'Active' },
  cancelled: { cls:'badge-danger',  l:'Cancelled' },
  trial:     { cls:'badge-info',    l:'Trial' },
}

const PLAN_COLOR = {
  Free:'#64748B', Starter:'#10B981', Pro:'#06B6D4', Enterprise:'#F59E0B'
}

export default function Subscription() {
  const [search, setSearch] = useState('')
  const [filter, setFilter] = useState('all')

  const filtered = SUBS.filter(s => {
    const matchStatus = filter === 'all' || s.status === filter
    const matchSearch = !search || s.user.toLowerCase().includes(search.toLowerCase()) || s.plan.toLowerCase().includes(search.toLowerCase())
    return matchStatus && matchSearch
  })

  const stats = [
    { label:'Total Revenue', value:'$128K', color:'#4F46E5', colorGlow:'rgba(79,70,229,0.18)',  icon:DollarSign,  variant:'indigo', trend:'+18%' },
    { label:'Active Subs',   value:SUBS.filter(s=>s.status==='active').length,    color:'#10B981', colorGlow:'rgba(16,185,129,0.15)', icon:Users,      variant:'green',  trend:'+5%' },
    { label:'Trial Users',   value:SUBS.filter(s=>s.status==='trial').length,     color:'#06B6D4', colorGlow:'rgba(6,182,212,0.15)',  icon:TrendingUp, variant:'cyan',   trend:'new', trendDir:'neutral' },
    { label:'Cancelled',     value:SUBS.filter(s=>s.status==='cancelled').length, color:'#EF4444', colorGlow:'rgba(239,68,68,0.15)',  icon:Crown,      variant:'red',    trend:'-1',  trendDir:'down' },
  ]

  return (
    <div className="dash-page page-in">

      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'var(--space-md)' }}>
        <h1 className="page-title">Subscriptions</h1>
      </div>

      {/* Stats */}
      {/* <div className="stats-grid cols-4">
        {stats.map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`}>
            <span style={{ position:'absolute', top:0, right:0, width:110, height:110, borderRadius:'50%', background:s.colorGlow, filter:'blur(30px)', transform:'translate(30%,-30%)', pointerEvents:'none' }}/>
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background:s.colorGlow, color:s.color }}><s.icon size={15} strokeWidth={1.8}/></div>
              <span className={`stat-card-trend${s.trendDir==='down'?' down':s.trendDir==='neutral'?' neutral':''}`}>{s.trend}</span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ position:'absolute', bottom:0, left:0, right:0, height:2, background:`linear-gradient(90deg,${s.color}88,transparent)`, borderRadius:'0 0 var(--radius-lg) var(--radius-lg)' }}/>
          </div>
        ))}
      </div> */}

      {/* Pricing Plans */}
      <div>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'var(--space-md)', flexWrap:'wrap', gap:'var(--space-sm)' }}>
          <h3 style={{ color:'var(--text1)', fontSize:'var(--fs-lg)', fontWeight:700, margin:0 }}>Pricing Plans</h3>
          <span style={{ fontSize:'var(--fs-xs)', color:'var(--text3)' }}>All plans include 14-day free trial</span>
        </div>
        <div className="sub-plans-grid">
          {PLANS.map(p => (
            <div key={p.id} className={`sub-plan-card${p.popular?' sub-plan-card--popular':''}`} style={{ '--plan-color': p.color, '--plan-glow': p.colorGlow }}>
              {p.popular && <div className="sub-plan-badge">Most Popular</div>}
              <span className="sub-plan-glow"/>
              <div className="sub-plan-top">
                <div>
                  <div className="sub-plan-name">{p.name}</div>
                  <div className="sub-plan-limit">{p.limit}</div>
                </div>
              </div>
              <div className="sub-plan-price">
                <span className="sub-plan-amount">{p.price}</span>
                <span className="sub-plan-billing">{p.billing}</span>
              </div>
              <ul className="sub-plan-features">
                {p.features.map(f => (
                  <li key={f}>
                    <span className="sub-plan-check"><Check size={9}/></span>
                    {f}
                  </li>
                ))}
              </ul>
              <div className="sub-plan-footer">
                <Users size={11} color={p.color}/>
                <span>{p.users} subscribers</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Subscribers */}
      <div className="card" style={{ padding:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:'var(--space-sm)', padding:'var(--space-md) var(--space-lg)', borderBottom:'1px solid var(--border)', flexWrap:'wrap' }}>
          <span style={{ fontSize:'var(--fs-md)', fontWeight:700, color:'var(--text1)', flex:1 }}>Subscribers</span>
          <div style={{ position:'relative', minWidth:180 }}>
            <Search size={13} style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', color:'var(--text3)' }}/>
            <input className="input" style={{ paddingLeft:32, height:34 }} placeholder="Search…" value={search} onChange={e=>setSearch(e.target.value)}/>
          </div>
          <div className="view-tabs" style={{ margin:0 }}>
            {['all','active','trial','cancelled'].map(f => (
              <button key={f} className={`vtab${filter===f?' active':''}`} onClick={()=>setFilter(f)}>
                {f.charAt(0).toUpperCase()+f.slice(1)}
              </button>
            ))}
          </div>
        </div>

        {/* Desktop table */}
        <div className="table-wrapper sub-table-desktop">
          <table className="data-table">
            <thead>
              <tr><th>ID</th><th>User</th><th>Plan</th><th>Amount</th><th>Started</th><th>Renews</th><th>Status</th></tr>
            </thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.id}>
                  <td style={{ fontFamily:'var(--font-mono)', fontSize:'var(--fs-xs)', color:'var(--accent-hover)' }}>{s.id}</td>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                      <div style={{ width:28, height:28, borderRadius:'50%', background:'var(--bg-active)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'var(--fs-xs)', fontWeight:700, color:'var(--accent-hover)', flexShrink:0 }}>
                        {s.user.split(' ').map(n=>n[0]).join('')}
                      </div>
                      <div>
                        <div style={{ fontWeight:600, color:'var(--text1)', fontSize:'var(--fs-sm)' }}>{s.user}</div>
                        <div style={{ fontSize:'var(--fs-xs)', color:'var(--text3)' }}>{s.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className="badge badge-gold" style={{ gap:4 }}>
                      <Crown size={10} color={PLAN_COLOR[s.plan]}/> {s.plan}
                    </span>
                  </td>
                  <td style={{ fontFamily:'var(--font-mono)', fontWeight:700, color:'var(--color-green)' }}>{s.amount}</td>
                  <td style={{ color:'var(--text3)', fontSize:'var(--fs-xs)' }}>{s.start}</td>
                  <td style={{ color:'var(--text3)', fontSize:'var(--fs-xs)' }}>{s.renew}</td>
                  <td><span className={`badge ${STATUS[s.status].cls}`}>{STATUS[s.status].l}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile cards */}
        <div className="sub-mobile-list">
          {filtered.map(s => (
            <div key={s.id} className="sub-mobile-item">
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                <div style={{ width:36, height:36, borderRadius:'50%', background:'var(--bg-active)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'var(--fs-sm)', fontWeight:700, color:'var(--accent-hover)', flexShrink:0 }}>
                  {s.user.split(' ').map(n=>n[0]).join('')}
                </div>
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontWeight:600, color:'var(--text1)', fontSize:'var(--fs-sm)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.user}</div>
                  <div style={{ fontSize:'var(--fs-xs)', color:'var(--text3)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{s.email}</div>
                </div>
                <span className={`badge ${STATUS[s.status].cls}`}>{STATUS[s.status].l}</span>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:6 }}>
                {[
                  { l:'Plan', v: <span style={{ color:PLAN_COLOR[s.plan], fontWeight:700 }}>{s.plan}</span> },
                  { l:'Amount', v: <span style={{ color:'var(--color-green)', fontFamily:'var(--font-mono)', fontWeight:700 }}>{s.amount}</span> },
                  { l:'Renews', v: s.renew },
                ].map(r => (
                  <div key={r.l} style={{ background:'var(--bg-raised)', borderRadius:'var(--radius-sm)', padding:'6px 8px' }}>
                    <div style={{ fontSize:9, color:'var(--text4)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:2 }}>{r.l}</div>
                    <div style={{ fontSize:'var(--fs-xs)', color:'var(--text2)' }}>{r.v}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .dash-page { display:flex; flex-direction:column; gap:var(--space-lg); width:100%; }

        /* Plans grid */
        .sub-plans-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: var(--space-md);
        }

        .sub-plan-card {
          position: relative;
          background: var(--bg-card);
          border: 1px solid var(--border);
          border-top: 2px solid var(--plan-color);
          border-radius: var(--radius-lg);
          padding: var(--space-lg);
          display: flex;
          flex-direction: column;
          gap: var(--space-md);
          transition: transform var(--ease-base), border-color var(--ease-base), box-shadow var(--ease-base);
          overflow: hidden;
        }

        .sub-plan-card:hover {
          transform: translateY(-3px);
          border-color: var(--plan-color);
          box-shadow: 0 8px 32px rgba(0,0,0,.2);
        }

        .sub-plan-card--popular {
          border-color: var(--plan-color);
          box-shadow: 0 0 0 1px var(--plan-color), 0 8px 32px rgba(79,70,229,0.15);
        }

        .sub-plan-badge {
          position: absolute;
          top: 14px; right: 14px;
          font-size: 9px; font-weight: 700;
          background: var(--plan-color);
          color: #fff;
          padding: 2px 8px;
          border-radius: var(--radius-full);
          text-transform: uppercase;
          letter-spacing: 0.06em;
        }

        .sub-plan-glow {
          position: absolute; top:0; right:0;
          width:100px; height:100px; border-radius:50%;
          background: var(--plan-glow);
          filter: blur(25px);
          transform: translate(30%,-30%);
          pointer-events: none;
        }

        .sub-plan-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .sub-plan-name {
          font-size: var(--fs-lg); font-weight: 700; color: var(--text1);
        }

        .sub-plan-limit {
          font-size: var(--fs-xs); color: var(--text3); margin-top: 2px;
        }

        .sub-plan-price {
          display: flex; align-items: baseline; gap: 4px;
        }

        .sub-plan-amount {
          font-size: 2rem; font-weight: 800;
          color: var(--plan-color);
          letter-spacing: -0.04em; line-height: 1;
        }

        .sub-plan-billing {
          font-size: var(--fs-xs); color: var(--text3);
        }

        .sub-plan-features {
          list-style: none; display: flex; flex-direction: column; gap: 7px; flex: 1;
        }

        .sub-plan-features li {
          display: flex; align-items: center; gap: 8px;
          font-size: var(--fs-xs); color: var(--text2);
        }

        .sub-plan-check {
          width: 15px; height: 15px; border-radius: 50%;
          background: var(--plan-glow); color: var(--plan-color);
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0; font-weight: 700;
        }

        .sub-plan-footer {
          display: flex; align-items: center; gap: 6px;
          padding: 7px 10px;
          background: var(--bg-raised);
          border-radius: var(--radius-sm);
          font-size: var(--fs-xs); color: var(--text3);
        }

        /* Mobile list */
        .sub-table-desktop { display: block; }
        .sub-mobile-list   { display: none; }

        .sub-mobile-item {
          padding: var(--space-md);
          border-bottom: 1px solid var(--border-subtle);
        }

        .sub-mobile-item:last-child { border-bottom: none; }

        /* Responsive */
        @media (max-width: 1100px) {
          .sub-plans-grid { grid-template-columns: repeat(2, 1fr); }
        }

        @media (max-width: 640px) {
          .sub-plans-grid { grid-template-columns: 1fr; }
          // .sub-table-desktop { display: none; }
          // .sub-mobile-list   { display: block; }
        }
      `}</style>
    </div>
  )
}